import { useCountrySelectionConfigSelector } from "@redux/reducers/appConfig";
import { useResolvedRegistrationCountry } from "@hooks/useResolvedRegistrationCountry";

export const useRegistrationCountryFilter = () => {
  const {
    enabled: isCountrySelectionEnabled,
    defaultCountry: domesticCountry,
  } = useCountrySelectionConfigSelector();
  const resolvedRegistrationCountry = useResolvedRegistrationCountry();

  return (countryOverride = undefined) => {
    if (!isCountrySelectionEnabled) {
      return {};
    }

    return {
      country:
        countryOverride || resolvedRegistrationCountry || domesticCountry,
      domesticCountry,
    };
  };
};
